import * as types from '../types';
import { ProductCategory } from '../types/Product';
import { cartContainsAnyFreeTrialBundle, cartContainsUltra, isBundleCartItem } from './cart';
import { getFiGrowthBook } from './growthbook';
import { giftHardwareSkuForTerm, giftTermOf } from './hardwareFirstGiftPlans';
import { getProductsBySku } from './product';

export function hardwareFirstGiftingFlagOn(): boolean {
  return getFiGrowthBook().getFeatureValue('hardware-first-gifting', false);
}

/** the cart's standalone trackers, the lines a gift covers */
export function giftableTrackers(cart: types.Cart, products: types.IProduct[]): types.CartItem[] {
  const productsBySku = getProductsBySku(products);
  return Object.values(cart.cartItems).filter((cartItem) => {
    const category = productsBySku.get(cartItem.lineItem.sku)?.category;
    return (
      !isBundleCartItem(cartItem) && (category === ProductCategory.COLLAR_KIT || category === ProductCategory.MINI)
    );
  });
}

/** trackers on their gift skus, or undefined unless web would take the cart as a gift; pricing and purchase both
 * send this, so they never disagree about the gift */
export function hardwareFirstGiftCartItems(cart: types.Cart, products: types.IProduct[]): types.CartItem[] | undefined {
  if (!('isGift' in cart) || !cart.isGift) {
    return undefined;
  }

  const termMonths = giftTermOf(cart);
  if (
    !termMonths ||
    !hardwareFirstGiftingFlagOn() ||
    cartContainsAnyFreeTrialBundle(cart, products) ||
    cartContainsUltra(cart, products)
  ) {
    return undefined;
  }

  const trackers = giftableTrackers(cart, products);
  const giftSkus = new Map(
    trackers.map((tracker) => [tracker.cartItemId, giftHardwareSkuForTerm(tracker.lineItem.sku, termMonths, products)]),
  );
  if (trackers.length === 0 || [...giftSkus.values()].some((sku) => !sku)) {
    return undefined;
  }

  return Object.values(cart.cartItems).map((cartItem) => {
    const giftSku = giftSkus.get(cartItem.cartItemId);
    return giftSku ? { ...cartItem, lineItem: { ...cartItem.lineItem, sku: giftSku } } : cartItem;
  });
}
